'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Front = _interopRequireDefault(require("Layouts/Front"));
var _Image = _interopRequireDefault(require("Pure/Image"));
var _Link = _interopRequireDefault(require("Pure/Link"));
var _PreparationEmploiIcon = _interopRequireDefault(require("Icons/PreparationEmploiIcon"));
var _FormationIcon = _interopRequireDefault(require("Icons/FormationIcon"));
var _MaintienEmploiIcon = _interopRequireDefault(require("Icons/MaintienEmploiIcon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
let app = window.app;
class RecrutementPage extends _react.Component {
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    let output = /*#__PURE__*/_react.default.createElement(_Front.default, _extends({
      page_title: "Recruteurs | AspieJob"
    }, props), /*#__PURE__*/_react.default.createElement("div", {
      className: "o-content"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "c-candidat-project"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "c-candidat-project__column c-candidat-project__column--txt"
    }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: "/recruteurs"
    }, "Recruteurs"), "/ ", /*#__PURE__*/_react.default.createElement("span", {
      className: "blue-text"
    }, "Recrutement et int\xE9gration de candidats")), /*#__PURE__*/_react.default.createElement("h1", {
      className: "c-title"
    }, "Recrutement et int\xE9gration de candidats"), /*#__PURE__*/_react.default.createElement("p", null, "Nous travaillons avec les ", /*#__PURE__*/_react.default.createElement("strong", null, "Ressources Humaines"), " afin de d\xE9finir les postes \xE0 proposer ainsi que les profils et les comp\xE9tences recherch\xE9s."), /*#__PURE__*/_react.default.createElement("p", null, "Nous sour\xE7ons les candidats titulaires d\u2019une ", /*#__PURE__*/_react.default.createElement("strong", null, "RQTH"), " (Reconnaissance de Qualit\xE9 de Travailleur Handicap\xE9) gr\xE2ce \xE0 notre ", /*#__PURE__*/_react.default.createElement("strong", null, "r\xE9seau"), " et \xE0 notre site internet ", /*#__PURE__*/_react.default.createElement("strong", null, "www.aspiejob.org"), ". Nous validons, en collaboration avec l\u2019entreprise, leur qualification pour le poste propos\xE9.")), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-candidat-project__column c-candidat-project__column--img"
    }, /*#__PURE__*/_react.default.createElement(_Image.default, {
      src: "/images/aspiejob-employeurs.svg",
      className: "c-candidat-project_img"
    }))), /*#__PURE__*/_react.default.createElement("h2", {
      className: "c-title c-title--medium u-text-center u-margin-top-40"
    }, "Une fois le candidat valid\xE9 par l\u2019entreprise, nous d\xE9ployons notre mod\xE8le d\u2019int\xE9gration dans l\u2019emploi qui est le suivant :"), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-integration-grid"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "c-integration-grid_item c-integration-grid_item--blue"
    }, /*#__PURE__*/_react.default.createElement("p", null, "Sensibilisation des diff\xE9rents acteurs (DRH, collectif de travail)")), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-integration-grid_item c-integration-grid_item--orange"
    }, /*#__PURE__*/_react.default.createElement("p", null, "Analyse du poste pour l\u2019adapter si n\xE9cessaire")), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-integration-grid_item c-integration-grid_item--green"
    }, /*#__PURE__*/_react.default.createElement("p", null, "Pr\xE9sentation du collaborateur aupr\xE8s du collectif de travail")), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-integration-grid_item c-integration-grid_item--pink"
    }, /*#__PURE__*/_react.default.createElement("p", null, "Choix et formation du tuteur r\xE9f\xE9rent")), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-integration-grid_item c-integration-grid_item--blue"
    }, /*#__PURE__*/_react.default.createElement("p", null, "Accompagnement du tuteur, de la DRH et du candidat (3 \xE0 6 mois)"))), /*#__PURE__*/_react.default.createElement("h2", {
      className: "c-title c-title--medium u-text-center u-margin-top-40"
    }, "Ce que nous vous proposons \xE9galement"), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-parcours-grid c-parcours-grid--4"
    }, /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: "/preparation-a-l-emploi",
      className: "c-parcours-grid-item c-parcours-grid-item--orange"
    }, /*#__PURE__*/_react.default.createElement(_PreparationEmploiIcon.default, {
      className: "c-parcours-grid-item__icon"
    }), /*#__PURE__*/_react.default.createElement("p", {
      className: "c-parcours-grid-item__txt"
    }, "Pr\xE9paration Op\xE9rationnelle \xE0 l\u2019Emploi"), /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: "/preparation-a-l-emploi",
      className: "c-parcours-grid-item__link"
    }, "En savoir plus")), /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: "/formation-sensibilisation",
      className: "c-parcours-grid-item c-parcours-grid-item--blue"
    }, /*#__PURE__*/_react.default.createElement(_FormationIcon.default, {
      className: "c-parcours-grid-item__icon"
    }), /*#__PURE__*/_react.default.createElement("p", {
      className: "c-parcours-grid-item__txt"
    }, "Formations & Sensibilisation"), /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: "/formation-sensibilisation",
      className: "c-parcours-grid-item__link"
    }, "En savoir plus")), /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: "/maintien-emploi",
      className: "c-parcours-grid-item c-parcours-grid-item--pink"
    }, /*#__PURE__*/_react.default.createElement(_MaintienEmploiIcon.default, {
      className: "c-parcours-grid-item__icon"
    }), /*#__PURE__*/_react.default.createElement("p", {
      className: "c-parcours-grid-item__txt"
    }, "Maintien en emploi"), /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: "/maintien-emploi",
      className: "c-parcours-grid-item__link"
    }, "En savoir plus")))));
    return output;
  }
}
exports.default = RecrutementPage;
